// @ts-nocheck
import { useMsal } from '@azure/msal-react'
import { NEW_LANDINGI_URL } from '@config/env'
import { getErrorMessage } from '@helpers/errorMessages'
import MicrosoftIcon from '@images/registration/microsoft_icon.svg'
import { useStepsContext } from '@pages/Authentication/contexts/steps'
import { loginWithOAuth } from '@services/authentication'
import { Button, emitTimingToast, Image, Spreader, Text } from '@ui-kit'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Row } from 'simple-flexbox'
import { useSWRConfig } from 'swr'

export const MicrosoftSignInButton = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const { startFromFirstStep } = useStepsContext()

  const { mutate } = useSWRConfig()

  const { instance } = useMsal()

  const handleSignIn = useCallback(async () => {
    try {
      const response = await instance.loginPopup({
        scopes: ['user.read', 'email', 'profile', 'openid'],
        prompt: 'select_account'
      })

      const { accessToken, idToken } = response

      await loginWithOAuth(accessToken, idToken, 'microsoft', NEW_LANDINGI_URL)

      startFromFirstStep()

      mutate('auth')
    } catch (error) {
      const { response } = error

      const code = response?.data.error.code

      emitTimingToast({
        message: t(getErrorMessage(code)),
        type: 'error'
      })
    } finally {
      setIsLoading(false)
    }
  }, [instance, mutate, startFromFirstStep, t])

  return (
    <Button
      variant='outlined'
      onClick={handleSignIn}
      size={16}
      disabled={isLoading}
      isLoading={isLoading}
      data-testid='microsoft-signin-button'
    >
      <Row alignItems='center' justifyContent='center'>
        <Image src={MicrosoftIcon} width='16px' height='16px' />

        <Spreader spread={10} />

        <Text size={16} weight={600} color='primary' lineHeight='normal'>
          {t('registration.flow.sign.in.microsoft')}
        </Text>
      </Row>
    </Button>
  )
}

MicrosoftSignInButton.displayName = 'MicrosoftSignInButton'
